export const primeVueFaLocale = {
  startsWith: 'شروع با',
  contains: 'شامل',
  notContains: 'شامل نباشد',
  endsWith: 'پایان با',
  equals: 'برابر',
  notEquals: 'نابرابر',
  noFilter: 'بدون فیلتر',
  lt: 'کمتر از',
  lte: 'کمتر یا مساوی',
  gt: 'بیشتر از',
  gte: 'بیشتر یا مساوی',
  dateIs: 'تاریخ برابر است با',
  dateIsNot: 'تاریخ برابر نیست با',
  dateBefore: 'تاریخ قبل از',
  dateAfter: 'تاریخ بعد از',
  clear: 'پاک‌کردن',
  apply: 'اعمال',
  matchAll: 'تطبیق همه',
  matchAny: 'تطبیق هرکدام',
  addRule: 'افزودن قانون',
  removeRule: 'حذف قانون',
  accept: 'تأیید',
  reject: 'رد',
  choose: 'انتخاب',
  upload: 'بارگذاری',
  cancel: 'انصراف',
  dayNames: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
  dayNamesShort: ['یک', 'دو', 'سه', 'چهار', 'پنج', 'جمعه', 'شنبه'],
  dayNamesMin: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
  monthNames: [
    'ژانویه',
    'فوریه',
    'مارس',
    'آوریل',
    'مه',
    'ژوئن',
    'ژوئیه',
    'اوت',
    'سپتامبر',
    'اکتبر',
    'نوامبر',
    'دسامبر'
  ],
  monthNamesShort: ['ژان', 'فور', 'مار', 'آور', 'مه', 'ژوئن', 'ژوئیه', 'اوت', 'سپت', 'اکت', 'نوام', 'دسام'],
  chooseYear: 'انتخاب سال',
  chooseMonth: 'انتخاب ماه',
  chooseDate: 'انتخاب تاریخ',
  prevDecade: 'دهه قبل',
  nextDecade: 'دهه بعد',
  prevYear: 'سال قبل',
  nextYear: 'سال بعد',
  prevMonth: 'ماه قبل',
  nextMonth: 'ماه بعد',
  prevHour: 'ساعت قبل',
  nextHour: 'ساعت بعد',
  prevMinute: 'دقیقه قبل',
  nextMinute: 'دقیقه بعد',
  prevSecond: 'ثانیه قبل',
  nextSecond: 'ثانیه بعد',
  am: 'ق.ظ',
  pm: 'ب.ظ',
  today: 'امروز',
  weekHeader: 'هفته',
  firstDayOfWeek: 6,
  dateFormat: 'yy/mm/dd',
  weak: 'ضعیف',
  medium: 'متوسط',
  strong: 'قوی',
  passwordPrompt: 'رمز عبور را وارد کنید',
  emptyFilterMessage: 'نتیجه‌ای یافت نشد',
  searchMessage: '{0} نتیجه در دسترس است',
  selectionMessage: '{0} مورد انتخاب شده است',
  emptySelectionMessage: 'موردی انتخاب نشده است',
  emptySearchMessage: 'نتیجه‌ای یافت نشد',
  emptyMessage: 'داده‌ای وجود ندارد',
  fileSizeTypes: ['بایت', 'کیلوبایت', 'مگابایت', 'گیگابایت', 'ترابایت', 'پتابایت', 'اگزابایت', 'زتابایت', 'یوتابایت'],
  aria: {
    trueLabel: 'درست',
    falseLabel: 'نادرست',
    nullLabel: 'انتخاب نشده',
    star: '۱ ستاره',
    stars: '{star} ستاره',
    selectAll: 'انتخاب همه',
    unselectAll: 'لغو انتخاب همه',
    close: 'بستن',
    previous: 'قبلی',
    next: 'بعدی',
    navigation: 'ناوبری',
    scrollTop: 'رفتن به ابتدای صفحه',
    moveTop: 'انتقال به ابتدا',
    moveUp: 'انتقال به بالا',
    moveDown: 'انتقال به پایین',
    moveBottom: 'انتقال به انتها',
    moveToTarget: 'انتقال به مقصد',
    moveToSource: 'انتقال به مبدأ',
    moveAllToTarget: 'انتقال همه به مقصد',
    moveAllToSource: 'انتقال همه به مبدأ',
    pageLabel: 'صفحه {page}',
    firstPageLabel: 'صفحه اول',
    lastPageLabel: 'صفحه آخر',
    nextPageLabel: 'صفحه بعد',
    prevPageLabel: 'صفحه قبل',
    rowsPerPageLabel: 'تعداد ردیف در صفحه',
    jumpToPageDropdownLabel: 'رفتن به صفحه از فهرست',
    jumpToPageInputLabel: 'رفتن به صفحه با ورودی',
    selectRow: 'انتخاب ردیف',
    unselectRow: 'لغو انتخاب ردیف',
    expandRow: 'بازکردن ردیف',
    collapseRow: 'بستن ردیف',
    showFilterMenu: 'نمایش منوی فیلتر',
    hideFilterMenu: 'پنهان‌کردن منوی فیلتر',
    filterOperator: 'عملگر فیلتر',
    filterConstraint: 'شرط فیلتر',
    editRow: 'ویرایش ردیف',
    saveEdit: 'ذخیره ویرایش',
    cancelEdit: 'لغو ویرایش',
    listView: 'نمای فهرست',
    gridView: 'نمای شبکه‌ای',
    slide: 'اسلاید',
    slideNumber: '{slideNumber}',
    zoomImage: 'بزرگ‌نمایی تصویر',
    zoomIn: 'بزرگ‌نمایی',
    zoomOut: 'کوچک‌نمایی',
    rotateRight: 'چرخش به راست',
    rotateLeft: 'چرخش به چپ'
  }
};

export default primeVueFaLocale;
